<template>
  <div id="shoushengqian">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>壽生钱</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">壽生钱</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/shou-sheng-qian.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『壽生钱』</h5>

                <p class="project-description">
                  <span><b>烧「寿生钱」可免18般横灾</b></span>
                </p>

                <p class="project-description">
                  <span><b>佛说寿生经： </b></span>
                </p>

                <p class="project-description">
                  唐朝贞观十三年，有唐三藏法师往西天求教，因检大藏经见寿生经一卷，有十三相属，南瞻部洲生下为人，先於冥司下各借壽生钱，有注命官祗揖人道：见今库藏空閒催南瞻部洲众生交纳寿生钱。
                </p>

                <p class="project-description">
                  阿难问世尊：南瞻部洲，众生多有大愿，不能纳得。佛言道：教看金刚经、寿生经能折本命钱，为祗证经。力甚大，若众生不纳寿生钱，睡中惊恐眠梦颠倒三魂杳杳，七魄幽幽，微生空中，其亡人语话相遂，摄人魂魄，减人精神，为欠寿生钱，若有善男，信女，愿纳寿生钱，可免得身边一十八般横灾。
                </p>

                <p class="project-description">
                  第一远路渡陌内被恶人窥算之灾，第二远路风雹雨打之灾，第三过江渡河落水之灾，第四墙倒屋塌之灾，第五火光之灾，第六血光之灾，第七劳病之灾，第八疥癞之灾，第九咽喉闭塞之灾，第十落马伤人之灾，第十一车碾之灾，第十二破伤风死之灾，第十三产难之灾，第十四横死之灾，第十五中风病之灾，第十六天行时气之灾，第十七投井自系之灾
                  第十八官事口舌之灾。
                </p>

                <p class="project-description">
                  若有善男子，善女人，纳得寿生钱，免了身边一十八般横灾。若有人不纳不折寿生钱，后世为人多注贫贱寿命不长，丑陋不堪，多饶残疾。但看注寿生经又名寿生经真经，不虚，除了身边灾，免了身边祸。
                </p>

                <p class="project-description">
                  又说十地菩萨，长寿王菩萨，摩诃萨延寿王菩萨摩诃萨，增福寿菩萨摩诃萨，消灾障菩萨摩诃萨救苦难观世音菩萨摩诃萨，长安乐菩萨摩诃萨，长欢喜菩萨摩诃萨，解冤结菩萨摩诃萨，福寿王菩萨摩诃萨，延寿长菩萨摩诃萨，本宅龙神土地罪消灭，满宅家眷罪消灭，恶口浪舌罪消灭，杀生害命罪消灭，前生冤业罪消灭，今生冤业罪消灭，前生殳母罪消灭，今生殳母罪消灭。
                </p>

                <p class="project-description">
                  又说灾星，金星、木星、水星、火星、土星、太阳星、太阴星、罗星、计都星、紫星、月星。忏悔己后，灾星不照，曜长临，四时无病，八节
                  无灾。若有善男子，善女人，早纳寿生钱，分明解脱，漏贯薄消纳在库中，库官收付，至百年命终之后，七七己前，早烧取寿生经，救度三世父母，七代先亡，九族冤魂，皆得生天。
                </p>

                <p class="project-description">
                  儒流学士，僧尼道俗，或贵或贱，若有善男子，善女人，今生早烧寿生钱，三世富今生不烧三世贫贱，后世难得人身，纵得为人，瘸手瘸足，无目跛腰，痴聋喑哑，衣不盖形，食不充口，被人轻贱。若早烧寿生钱，注衣注食注命注禄。
                </p>

                <p class="project-description">
                  阿难再问世尊：众生要如何纳寿生钱？佛曰：填上姓名生辰寫上經文，當天焚燒即可。
                </p>

                <p class="project-description">
                  如今諸葛孔明有限公司所製之寿生钱，更加簡單，只要將盒內所附之經文在空白處填上姓名出生日期、時間。當天焚燒即可。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="shou-sheng-qian" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "ShouShengQian",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/ShouShengQian.vue